import "./Navbar.scss";

import React, { memo } from "react";

import {
  BreakpointKeys,
  breakpoints,
} from "@/covaltech-react-ui/config/breakpoints";
import useWindowWidth from "@/covaltech-react-ui/hooks/useWindowWidth";

import MobileNavbar from "./MobileNavbar/MobileNavbar";
import TopNavbar from "./TopNavbar/TopNavbar";

export type NavItemType = {
  type?: "submenu" | "link";
  href?: string;
  link?: string;
  text: string;
  icon?: React.ReactNode;
  className?: string;
  submenu?: NavItemType[];
  hilight?: boolean;
};

interface NavbarProps {
  navItems: NavItemType[];
  beforeChildren?: React.ReactNode;
  children?: React.ReactNode;
  mobileBeforeChildren?: React.ReactNode;
  mobileChildren?: React.ReactNode;
  showLogo?: boolean;
  showLinkLogo?: boolean;
  breakpoint?: BreakpointKeys;
  scrollToContainer?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({
  navItems,
  children,
  beforeChildren,
  mobileBeforeChildren,
  mobileChildren,
  showLogo = true,
  showLinkLogo = true,
  breakpoint = "breakpoint-lg-4",
  scrollToContainer = false,
}) => {
  const { windowWidth } = useWindowWidth();

  const isDesktop = windowWidth > breakpoints[breakpoint];

  return (
    <>
      {isDesktop ? (
        <TopNavbar
          navItems={navItems}
          beforeChildren={beforeChildren}
          showLogo={showLogo}
          showLinkLogo={showLinkLogo}
        >
          {children}
        </TopNavbar>
      ) : (
        <MobileNavbar
          navItems={navItems}
          showLinkLogo={showLinkLogo}
          mobileBeforeChildren={mobileBeforeChildren}
          scrollToContainer={scrollToContainer}
        >
          {mobileChildren}
        </MobileNavbar>
      )}
    </>
  );
};

export default memo(Navbar);
